<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :visible.sync="visibleDx"
    width="700px"
    custom-class="vms-ztdx-dialog"
    title=""
    :before-close="beforeClose"
  >
    <div style="text-align: center;margin-bottom: 12px;color: #000;">
      <!-- 您导出的视频中包含第三方素材,需要提交素材使用方的基本信息才可<br>导出并进行商用 -->
      您在视频中使用了第三方正版素材，请填写授权主体信息，我们会告知版权方从而保护您的权益。<br>VIP期间制作并且已经公开发表的作品，该作品可获得永久传播授权。
    </div>
    <el-form
      ref="dxForm"
      :model="form"
      :rules="rules"
      label-width="150px"
    >
      <el-form-item
        label="企业名称"
        prop="company"
        class="vms-ztdx-dialog-input"
      >
        <el-input
          v-model="form.company"
          placeholder="企业名称要求3≤N≤20个字符"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="手机号码"
        prop="phone"
        class="vms-ztdx-dialog-input"
      >
        <el-input
          v-model="form.phone"
          placeholder="请输入您的手机号码"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="图形验证码"
        prop="captcha"
        class="vms-ztdx-dialog-input input-sort"
      >
        <el-input
          v-model="form.captcha"
          placeholder="请输入图形验证码"
        ></el-input>
        <img
          class="input-captcha"
          style="position: absolute;height:40px;top:-2px;right:-130px;margin-left:16px;"
          :src="captchaUrl"
          @click="refreshCaptcha"
        >
      </el-form-item>
      <el-form-item
        label="手机验证码"
        prop="code"
        class="vms-ztdx-dialog-input input-sort"
      >
        <el-input
          v-model="form.code"
          placeholder="请输入验证码"
        ></el-input>
        <el-button
          ref="regBtn"
          style="position: absolute;top:0px;right:-130px;margin-left: 20px;"
          type="primary"
          :disabled="regBtn.disabled"
          @click="reSendVerifyCode"
        >
          {{ regBtn.text }}
        </el-button>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        round
        @click="submit('dxForm')"
      >
        提交并导出
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapMutations, mapGetters } from "vuex"
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    // 校验名字长度大于3
    var checkCompanyName = (rule, value, callback) => {
      if (value && value.length < 3) {
        callback(new Error("企业名称必须大于或等于3个字符"))
      }
      callback()
    }
    //手机号格式校验
    var phoneReg = (rule, value, callback) => {
      const reg = /^(0|86|17951|12593)?((13[0-9])|(14[014]0[0-9])|(14[5-9])|(15([0-3]))|(15([5-9]))|(16[2567])|(170[0-9])|(174[0-5])|(17[1235678])|(18[0-9])|(19[012356789]))\d{8}$/;
      if (!reg.test(value) && value != "") {
        callback(new Error("电话号码格式不正确"))
      }
      callback()
    }
    //验证码校验
    var codeCheck = async (rule, value, callback) => {
      if (this.submiting) {
        let msg = await this.checkVerifyCode(this.form.phone, this.form.code)
        if (msg != "true") {
          callback(new Error(msg))
        }
      }
      callback()
    }
    var captchaCheck = async (rule, value, callback) => {
      if (!this.isSendCode) {
        let msg = await this.checkCaptchaImg(this.form.captcha)
        if (msg != "true") {
          callback(new Error(msg))
        }
      }
      callback()
    }
    return {
      captchaUrl: "", //图形验证码
      countdown: 60,
      regBtn: {
        disabled: false,
        text: "发送验证码"
      },
      submiting: false, //提交中
      form: {
        company: "",
        phone: "",
        captcha: "",
        code: "",
      },
      rules: {
        company: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
          { validator: checkCompanyName }
        ],
        phone: [
          { required: true, message: "请填写您的常用手机", trigger: "blur" },
          { validator: phoneReg, trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
          { validator: captchaCheck, trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: codeCheck, trigger: "blur" }
        ],
      },
    }
  },
  computed: {
    ...mapGetters([
      'Company'
    ]),
    visibleDx () {
      return this.value
    }
  },
  watch: {
    visibleDx (val) {
      if (val) {
        this.refreshCaptcha()
        // this.$http.get("/api/user/info/applyInfo?type=13").then((res) => {
        //   if (res.data.code == 200) {
        //     if (!res.data.data) {
        //       return
        //     }
        //     if (!res.data.data.name) {
        //       this.form.company = ""
        //     } else {
        //       this.form.company = res.data.data.name
        //     }
        //     if (!res.data.data.phone) {
        //       this.form.phone = ""
        //     } else {
        //       this.form.phone = res.data.data.phone
        //     }
        //   }
        // })
        this.form.company = this.Company.name;
        this.form.phone = this.Company.phone;
      }
    }
  },
  mounted () {
    this.refreshCaptcha()
    // this.$http.get("/api/user/info/applyInfo?type=13").then((res) => {
    //   if (res.data.code == 200) {
    //     if (!res.data.data) {
    //       return
    //     }
    //     if (!res.data.data.name) {
    //       this.form.company = ""
    //     } else {
    //       this.form.company = res.data.data.name
    //     }
    //     if (!res.data.data.phone) {
    //       this.form.phone = ""
    //     } else {
    //       this.form.phone = res.data.data.phone
    //     }
    //   }
    // })
    this.form.company = this.Company.name;
    this.form.phone = this.Company.phone;
    $(this.$children[0].$el).on('keydown', (ev) => {
      ev.stopPropagation()
    })
  },
  beforeDestroy () {
    // this.beforeClose();
  },
  methods: {
    // ...mapMutations(["changeLogin"]),
    //更新图形验证码
    refreshCaptcha () {
      this.form.captcha = ""
      var times = Date.parse(new Date())
      this.captchaUrl = "/api/verify/imgCaptcha/new" + "?num=" + times
    },
    //图形验证码校验
    checkCaptchaImg (captcha) {
      return new Promise((resolve, reject) => {
        this.$http
          .put("/api/verify/imgCaptcha", {
            captcha: captcha
          })
          .then(response => {
            var _data = response.data
            if (_data.code == 200) {
              resolve("true")
            } else {
              resolve("图形验证码错误")
            }
          })
          .catch(response => {
            //失败
            reject()
          })
      })
    },
    /**
     * 重新发送验证码
     */
    async reSendVerifyCode () {
      let flag = true
      //验证手机号
      this.$refs["dxForm"].validateField("phone", res => {
        flag = res ? false : true
        //验证图形验证码
        this.$refs["dxForm"].validateField("captcha", res => {
          flag = res ? false : true
          if (!flag) {
            return
          }
          if (!this.isSendCode) {
            this.sendVerifyCode()
            this.regBtn.disabled = true
          } else {
            this.refreshCaptcha()
            this.form.code = ""
            this.form.captcha = ""
            this.isSendCode = false
            this.$message("请重新输入图形验证码")
          }
        })
      })
    },
    //发送验证码
    sendVerifyCode () {
      this.$http
        .get("/api/verify/new", {
          params: {
            phone: this.form.phone,
            email: "",
            captcha: this.form.captcha
          }
        })
        .then(response => {
          var _data = response.data
          if (_data.code == 200) {
            this.setTime()
            this.isSendCode = true
          } else {
            this.$message.error(_data.msg)
            this.regBtn.disabled = false
          }
        })
        .catch(response => {
          //失败
          this.regBtn.disabled = false
        })
    },
    //验证码计时
    setTime () {
      if (this.countdown == 0) {
        this.stop_msg = false
        this.regBtn.disabled = false
        this.regBtn.text = "重新获取验证码"
        this.countdown = 60
        return false
      } else {
        this.stop_msg = true
        this.regBtn.disabled = true
        this.countdown--
        this.regBtn.text = "重新发送(" + this.countdown + ")"
      }
      setTimeout(() => {
        this.setTime()
      }, 1000)
    },
    //校验验证码
    checkVerifyCode (phone, code) {
      return new Promise((resolve, reject) => {
        this.$http
          .put("/api/verify", {
            phone: phone,
            email: "",
            code: code
          })
          .then(response => {
            var _data = response.data
            if (_data.code == 200) {
              resolve("true")
            } else {
              resolve(_data.msg)
            }
          })
          .catch(response => {
            //失败
            reject()
          })
      })
    },
    // 关闭弹窗前的动作
    beforeClose () {
      this.$refs.dxForm.resetFields()
      this.fileList = []
      this.form = {
        company: "",
        phone: "",
        captcha: "",
        code: "",
      }
      this.$emit("input", false)
      $('body>.v-modal').fadeOut()
    },
    submit (formName) {
      this.submiting = true
      this.$refs[formName].validate(async valid => {
        this.submiting = false
        if (valid) {
          this.$bus.emit('expertVideoAfterCompanyInfo', {
            company: this.form.company,
            phone: this.form.phone,
          });
          // this.$http.put("/api/user/info/updateCompany", {
          //   company: this.form.company,
          //   phone: this.form.phone,
          // })
          //   .then(async res => {
          //     if (res.data.code == 200) {
          //       // await this.refreshSession()
          //       // this.$emit("input", false)
          //       this.$emit("applySuccess")

          //     } else {
          //       this.$message.error(res.data.msg)
          //       this.refreshCaptcha()
          //       this.regBtn.disabled = false
          //       this.form.code = ""
          //       this.regBtn.text = "获取验证码"
          //       this.countdown = 0
          //     }
          //   })
          //   .catch(res => { })
        }
      })
    },
    // 刷新session
    refreshSession () {
      this.$http.get("/api/session/new").then(res => {
        if (res.data.code == 200) {
          this.changeLogin(res.data.data)
        }
      })
    },

    autoFillForm () {

    }
  }
};
</script>
<style lang="scss">
.vms-ztdx-dialog {
  .dialog-input {
    input,
    textarea {
      width: 600px;
      background-color: #f6f6fc;
      border: 0;
      border-radius: 0;
    }
    &.input-sort input {
      width: 280px;
    }
    &.input-sort-short input {
      width: 150px;
    }
    .el-input {
      display: inline;
    }
    .input-captcha {
      position: absolute;
      margin-top: -10px;
      width: 112px;
      height: 40px;
      cursor: pointer;
    }
  }
  .el-dialog__body {
    width: 540px;
    .el-form-item__label {
      &::before {
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
      }
    }
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  &-input {
    width: 400px;
  }
  &-upload {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
    .el-upload-list {
      text-align: left;
      width: 250px;
      .el-upload-list__item-name {
        max-width: 205px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .upload-tips {
    position: absolute;
    top: 228px;
    left: 344px;
    color: #4e6ce2;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: rgba(#4e6ce2, 0.8);
    }
  }
  &-tips {
    margin-left: 148px;
    font-size: 12px;
    line-height: 18px;
    text-align: left;
    .el-icon-warning {
      margin-right: 4px;
      color: #4e6ce2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/companyInfo.vue